export default {
    bindings: {
        guest: '=',
        item: '=',
        options: '<'
    },
    controller: 'selectOptionsController',
    template: require('../views/select.options.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/components/select.options.component.js